export const mockTemplateHelpdesk = [
    {
        displayName: "Conta",
        atributos: [
            {
                parametro: "TB_CMCRM_CONTA.DS_NOME",
                campo: "CLIENTE.NOME",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTA.ID_CHAVE_ERP",
                campo: "CLIENTE.CHAVE_ERP",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTA.DT_NASCIMENTO",
                campo: "CLIENTE.DT_NASCIMENTO",
                tipo: "DATETIME",
            },
            {
                parametro: "TB_CMCRM_CONTA.DS_SEXO",
                campo: "CLIENTE.SEXO",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTA.NR_CPF",
                campo: "CLIENTE.CPF",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTA.NR_RG",
                campo: "CLIENTE.RG",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTA.DS_EMAIL",
                campo: "CLIENTE.EMAIL",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTA.DS_NOME_PAI",
                campo: "CLIENTE.NOME_PAI",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTA.DS_NOME_MAE",
                campo: "CLIENTE.NOME_MAE",
                tipo: "TEXT",
            },
        ],
    },
    {
        displayName: "Contato",
        atributos: [
            {
                parametro: "TB_CMCRM_CONTATO.DS_TIPO_RELACAO_CLIENTE",
                campo: "CONTATO.TIPO_RELACAO_CLIENTE",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTATO.DS_NOME",
                campo: "CONTATO.NOME",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTATO.NR_CPF",
                campo: "CONTATO.CPF",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTATO.DS_EMAIL",
                campo: "CONTATO.EMAIL",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTATO.ID_CHAVE_ERP",
                campo: "CONTATO.CHAVE_ERP",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTATO.NR_RG",
                campo: "CONTATO.RG",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CONTATO.DT_NASCIMENTO",
                campo: "CONTATO.DT_NASCIMENTO",
                tipo: "DATETIME",
            },
        ],
    },
    {
        displayName: "Unidade",
        atributos: [
            {
                parametro: "TB_CMCRM_PRODUTO.DS_UNIDADE",
                campo: "UNIDADE.IDENTIFICADOR",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_PRODUTO.DS_EMPREENDIMENTO",
                campo: "UNIDADE.EMPREENDIMENTO",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_PRODUTO.DT_VENDA",
                campo: "UNIDADE.DT_VENDA",
                tipo: "DATETIME",
            },
            {
                parametro: "TB_CMCRM_PRODUTO.ID_CHAVE_ERP",
                campo: "UNIDADE.CHAVE_ERP",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_PRODUTO.VL_TOTAL_PRODUTO",
                campo: "UNIDADE.TOTAL_PRODUTO",
                tipo: "MOEDA OU TEXT",
            },
        ],
    },
    {
        displayName: "Usuário",
        atributos: [
            {
                parametro: "TB_CMC_USUARIO.DS_EMAIL",
                campo: "ATENDENTE.EMAIL",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMC_USUARIO.DS_NOME",
                campo: "ATENDENTE.NOME",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMC_USUARIO.NR_RG",
                campo: "ATENDENTE.RG",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMC_USUARIO.NR_CPF",
                campo: "ATENDENTE.CPF",
                tipo: "TEXT",
            },
        ],
    },
    {
        displayName: "Cobrança Preventivo",
        atributos: [
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.VL_PARCELA",
                campo: "PREVENTIVO.VALOR PARCELA",
                tipo: "MOEDA",
            },
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.DS_LINHA_DIGITAVEL",
                campo: "PREVENTIVO.LINHA_DIGITAVEL",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.DT_VENCIMENTO",
                campo: "PREVENTIVO.DT_VENCIMENTO",
                tipo: "DATETIME",
            },
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS_A_RECEBER.NR_AGING_PARCELA",
                campo: "PREVENTIVO.NR_AGING",
                tipo: "TEXT",
            },
        ],
    },
    {
        displayName: "Cobrança",
        atributos: [
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO.NR_PARCELAS_EM_ABERTO",
                campo: "COBRANCA.NR_PARCELAS_EM_ABERTO",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO.VL_PARCELAS_EM_ABERTO",
                campo: "COBRANCA.TOTAL DA DÍVIDA",
                tipo: "MOEDA",
            },
        ],
    },
    {
        displayName: "Cobrança Parcelas",
        atributos: [
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.VL_PARCELA",
                campo: "COBRANCA PARCELAS.VALOR DA PARCELA",
                tipo: "MOEDA",
            },
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.DT_VENCIMENTO",
                campo: "COBRANCA PARCELAS.DATA VENCIMENTO",
                tipo: "DATETIME",
            },
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.NR_AGING_DIAS_CONTRATO",
                campo: "COBRANCA PARCELAS.AGING DA PARCELA",
                tipo: "TEXT",
            },
            {
                parametro: "TB_CMCRM_CASO_COBRANCA_FATO_PARCELAS.DS_LINHA_DIGITAVEL",
                campo: "COBRANCA PARCELAS.LINHA DIGITAVEL",
                tipo: "TEXT",
            },
        ],
    },
];
